<!-- **** blocking warning **** -->
<div *ngIf="receiverIsBlocked" class="beingBlocked">
  <p *ngIf="receiverInfo?.username" class="vc-text-m beingBlocked__info" i18n="@@CHAT.FORM.INTERLOCUTOR_BLOCKED">
    You blocked {{ receiverInfo.username }}
  </p>
  <p class="vc-text-m beingBlocked__csq" i18n="@@CHAT.FORM.INTERLOCUTOR_BLOCKED.CSQ">You cannot send a message</p>
</div>
<div *ngIf="senderIsBlocked" class="beingBlocked">
  <p *ngIf="receiverInfo?.username" class="vc-text-m beingBlocked__info" i18n="@@CHAT.FORM.YOURSELF_BLOCKED">
    You've been blocked by {{ receiverInfo.username }}
  </p>
  <p class="vc-text-m beingBlocked__csq" i18n="@@CHAT.FORM.YOURSELF_BLOCKED.CSQ">You cannot send a message</p>
</div>
<!-- **** banning warning **** -->
<div *ngIf="receiverIsBanned" class="beingBlocked">
  <p *ngIf="receiverInfo?.username" class="vc-text-m beingBlocked__info" i18n="@@CHAT.FORM.INTERLOCUTOR_BANNED">
    {{ receiverInfo.username }} is no longer able to receive messages
  </p>
  <p class="vc-text-m beingBlocked__csq" i18n="@@CHAT.FORM.INTERLOCUTOR_BANNED.CSQ">You cannot send a message.</p>
</div>
<div *ngIf="senderIsBanned" class="beingBlocked">
  <p class="vc-text-m beingBlocked__info" i18n="@@CHAT.FORM.YOURSELF_BANNED">You've been banned from the chat.</p>
  <a
    href="https://faq.vestiairecollective.com/hc/en-us/articles/360011181318-Why-have-I-been-banned-"
    class="vc-text-m beingBlocked__csq"
    i18n="@@CHAT.FORM.YOURSELF_BANNED.CSQ"
    i18n-href="@@CHAT.FORM.YOURSELF_BANNED.FAQ"
  >
    Read more about ban.
  </a>
</div>

<!-- **** bottom part with content discussion **** -->
<div #chatWrapper class="chat">
  <div class="chat__top">
    <div #chatContent class="msgChat">
      <span class="msgChat__pic msgChat__pic--disclaimer">
        <vc-sprite-icons name="logo-v"></vc-sprite-icons>
      </span>
      <p class="msgChat__content__item msgChat__content__item--disclaimer vc-text-s" i18n="@@CHAT.CONTENT.DISCLAIMER">
        Hi! Vestiaire Collective is in copy of this chat and may monitor it for fraud, safety reasons, and quality of
        service - see
        <a
          i18n-href="@@CHAT.CONTENT.DISCLAIMER.LINK_POLICY"
          href="https://www.vestiairecollective.com/documents/cgu-personal-data-en.pdf"
          class="vc-link"
          >Privacy Policy</a
        >. If you need our assistance, please
        <a
          i18n-href="@@CHAT.CONTENT.DISCLAIMER.LINK_CONTACT"
          href="https://faq.vestiairecollective.com/hc/en-us/requests/new?ticket_form_id=360000167277&n=3#top_form"
          class="vc-link"
          >contact us</a
        >
      </p>
    </div>

    <ul>
      <!-- ** First msg intro ** -->
      <li *ngIf="!isSeller" class="msgChat">
        <vc-ref
          [isFlex]="true"
          i18n-resource="@@CHAT.CONTENT.INTERLOCUTOR_PROFILE_LINK"
          resource="/members/profile-{{ receiverInfo && receiverInfo.id }}.shtml"
        >
          <span
            class="msgChat__pic"
            [style.backgroundImage]="'url(https://vestiairecollective.imgix.net' + receiverInfo?.picture.path + ')'"
          ></span>
          <div class="msgChat__content vc-text-l">
            <p *ngIf="receiverInfo" class="msgChat__content__item" i18n="@@CHAT.CONTENT.INTRO_SELLER">
              Hello I'm {{ receiverInfo.username }}
            </p>
          </div>
        </vc-ref>
      </li>
      <!-- End first msg intro -->

      <li class="chat__loading" *ngIf="isLoading">
        <div class="chat__loading__icon">
          <vc-sprite-icons name="spinner"></vc-sprite-icons>
        </div>
      </li>

      <!-- ** Beginning of discussion ** -->
      <li class="chat__content" *ngFor="let message of messages | groupMessages | keyvalue">
        <div class="dateChat vc-text-xs">{{ message.key | date: 'short':'':locale }}</div>
        <div
          class="msgChat"
          *ngFor="let item of message.value; let itemIndex = index"
          [ngClass]="{'msgChat--sender': item.user.id === userId}"
        >
          <!-- PICTURE DISPLAY -->
          <ng-container>
            <!-- /receiver case  -->
            <vc-ref
              [isFlex]="true"
              i18n-resource="@@CHAT.CONTENT.INTERLOCUTOR_PROFILE_LINK"
              resource="/members/profile-{{ receiverInfo && receiverInfo.id }}.shtml"
            >
              <span
                *ngIf="userId !== item.user.id"
                class="msgChat__pic"
                [style.backgroundImage]="
                  message.value[itemIndex + 1]?.user.id !== item.user.id
                    ? 'url(https://vestiairecollective.imgix.net' + receiverInfo?.picture?.path + ')'
                    : ''
                "
              ></span>
            </vc-ref>
          </ng-container>
          <!-- CONTENT DISPLAY -->
          <ng-container>
            <div
              class="msgChat__content vc-text-l"
              [ngClass]="{'msgChat__content--failed': item.status === tempStatus.NO_NETWORK}"
              (click)="retryToSend(item.id)"
            >
              <ng-container *ngIf="item.rewritten_by_presend_hook; else originalMsg">
                <p class="msgChat__content__item msgChat__content__item--abusive" i18n="@@CHAT.CONTENT.MSG_DELETED">
                  Message deleted
                </p>
              </ng-container>
              <ng-template #originalMsg>
                <p
                  class="msgChat__content__item"
                  [innerText]="
                    userId !== item.user.id
                      ? (translated && item.i18n && item.i18n[locale + '_text']) || item.text
                      : item.text
                  "
                ></p>
              </ng-template>

              <!-- call offline to the library, need to be inline -->
              <svg
                *ngIf="item.status === tempStatus.NO_NETWORK"
                class="msgChat__content__svg"
                version="1.1"
                id="Calque_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 32 32"
                style="enable-background:new 0 0 32 32;"
                xml:space="preserve"
              >
                <g>
                  <path
                    fill="currentColor"
                    d="M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0c8.8,0,16,7.2,16,16S24.8,32,16,32z M16,2.3C8.4,2.3,2.3,8.4,2.3,16S8.4,29.7,16,29.7
                        c7.6,0,13.7-6.2,13.7-13.7S23.6,2.3,16,2.3z"
                  />
                  <path
                    fill="currentColor"
                    d="M14.7,10.6V7.4h2.6v3.3C17.3,10.6,14.7,10.6,14.7,10.6z M14.7,24.6v-12h2.6v12C17.3,24.6,14.7,24.6,14.7,24.6z"
                  />
                </g>
              </svg>
            </div>
          </ng-container>
          <!-- MESSAGE WARNING -->
          <ng-container *ngIf="userId === item.user.id; else aboutInterlocutor">
            <!-- /status msg = sending -->
            <p
              *ngIf="item.status === tempStatus.SENDING"
              class="msgChat__info vc-text-xs"
              i18n="@@CHAT.CONTENT.MSG_SENDING"
            >
              Sending...
            </p>
            <!-- /status msg = send -->
            <p
              *ngIf="
                !msgBeenRead && item.status === 'received' && item.type !== 'deleted' && !item.rewritten_by_presend_hook
              "
              class="msgChat__info vc-text-xs"
              i18n="@@CHAT.CONTENT.MSG_SENT"
            >
              Sent
            </p>
            <!-- /status msg = seen -->
            <p
              *ngIf="
                msgBeenRead && item.status === 'received' && item.type !== 'deleted' && !item.rewritten_by_presend_hook
              "
              class="msgChat__info vc-text-xs"
              i18n="@@CHAT.CONTENT.MSG_SEEN"
            >
              Read
            </p>
            <!-- /low connection case -->
            <p
              *ngIf="item.status === tempStatus.NO_NETWORK"
              class="msgChat__info msgChat__info--failed vc-text-s"
              i18n="@@CHAT.CONTENT.MSG_FAILED"
            >
              Not delivered - Tap to retry
            </p>

            <!-- /abusive case -->
            <div *ngIf="item.rewritten_by_presend_hook" class="msgChat__info msgChat__info--abusive vc-text-m">
              <p i18n="@@CHAT.CONTENT.MSG_FLAGGED_WARNING_SENT">
                It seems that you’ve sent a message which does not comply with our
                <a
                  href="https://www.vestiairecollective.com/documents/cgu-all-en.pdf"
                  class="vc-link"
                  i18n-href="@@CHAT.CONTENT.MSG_FLAGGED_WARNING.LINK"
                >
                  terms</a
                >
                and it will be reviewed by our moderation team. You’ll be excluded from Chat if you try to complete a
                sale elsewhere.
              </p>
            </div>
          </ng-container>
          <ng-template #aboutInterlocutor>
            <div
              *ngIf="item.rewritten_by_presend_hook"
              class="msgChat__info msgChat__info--abusive msgChat__info--abusive--received vc-text-m"
            >
              <p i18n="@@CHAT.CONTENT.MSG_FLAGGED_WARNING_RECEIVED">
                This user sent a message which does not comply with our
                <a
                  href="https://www.vestiairecollective.com/documents/cgu-all-en.pdf"
                  class="vc-link"
                  i18n-href="@@CHAT.CONTENT.MSG_FLAGGED_WARNING.LINK"
                >
                  terms</a
                >. Keep your personal info safe; only purchase through Vestiaire.
              </p>
            </div>
          </ng-template>
        </div>
      </li>
    </ul>

    <!-- translation btn -->
    <div class="chat__translation" *ngIf="receiverInfo && receiverInfo.language?.name !== locale">
      <span class="vc-text-s" i18n="@@CHAT.CONTENT.TRANSLATE_CONVERSATION">
        Received messages are translated
      </span>
      <!-- TO DO: original sentence : Received messages are translated from Interlocutor's language -->
      <!-- <span class="chat__translation__original vc-text-s" [ngSwitch]="localInterlocutor">
        <ng-container *ngSwitchCase="'fr'" i18n="@@CHAT.CONTENT.TRANSLATE_FRENCH">French</ng-container>
        <ng-container *ngSwitchCase="'de'" i18n="@@CHAT.CONTENT.TRANSLATE_GERMAN">German</ng-container>
        <ng-container *ngSwitchCase="'it'" i18n="@@CHAT.CONTENT.TRANSLATE_ITALIAN">Italian</ng-container>
        <ng-container *ngSwitchCase="'es'" i18n="@@CHAT.CONTENT.TRANSLATE_SPANISH">Spanish</ng-container>
        <ng-container *ngSwitchDefault i18n="@@CHAT.CONTENT.TRANSLATE_ENGLISH">English</ng-container>
      </span> -->
    </div>
  </div>
</div>
